import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import { Tag, TagType } from '~core/models/tag.models';
import { TagService } from './tag.service';

export const sectorsResolver: ResolveFn<Pagination<Tag>> = (
  route,
  state
): Observable<Pagination<Tag>> => {
  const tagService = inject(TagService);
  return tagService.list({ type: TagType.SECTOR, itemPerPage: 1_000 });
};
